import download from 'downloadjs';

/**
 * Escape a single CSV cell value per RFC 4180. Wraps in double quotes and
 * doubles any internal quotes if the value contains comma, quote, CR or LF.
 */
function escapeCsvCell(value) {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

/**
 * Build a CSV string from an array of row objects.
 *
 * @param {Array<Object>} rows - row objects keyed by header keys
 * @param {Array<{key: string, label: string}>} headers - ordered headers
 * @returns {string} CSV text (CRLF line endings)
 */
export function buildCsv(rows, headers) {
  const lines = [];
  lines.push(headers.map((h) => escapeCsvCell(h.label)).join(','));
  for (const row of rows) {
    lines.push(headers.map((h) => escapeCsvCell(row[h.key])).join(','));
  }
  return lines.join('\r\n');
}

/**
 * Trigger a browser download of a CSV string. Prepends a UTF-8 BOM so Excel
 * picks up encoding correctly when the file is double-clicked.
 */
export function downloadCsv(filename, csv) {
  const withBom = `\uFEFF${csv}`;
  const blob = new Blob([withBom], { type: 'text/csv;charset=utf-8' });
  download(blob, filename, 'text/csv;charset=utf-8');
}
